export default __webpack_public_path__ + "static/media/phone-delivery.5279d431.svg";